import type { RouteLocationNormalized, RouteLocationRaw } from 'vue-router';

// Query params that don't survive entering the positions subtree.
//
// - `positionId`: inside positions the active position lives in the path param,
//   so `?positionId` is strictly an out-of-tab concept.
// - `fileId`: only stale on the bare `/positions` entry point. Every other order
//   tab keeps a file selected in the query, and clicking through to positions
//   drags that file along — which would drop the user straight into a file view
//   instead of the position list. Locations that name a position or the inbox
//   (deep links, "open this file where it lives") mean their fileId, so it stays.
export function stripStalePositionsQuery(
  to: RouteLocationNormalized
): true | RouteLocationRaw {
  const staleKeys = ['positionId'];
  if (to.name === 'order:positions') staleKeys.push('fileId');

  const stale = staleKeys.filter((key) => to.query[key] !== undefined);
  if (!stale.length) return true;

  const query = { ...to.query };
  stale.forEach((key) => delete query[key]);
  return { path: to.path, query, hash: to.hash };
}
